<div class="card" [routerLink]="element.url">
    <div class="card-header">
        <img [hidden]="loading" class="card-img" (load)="loaded ? imgLoaded=true : ''" [src]="image" alt="{{element.reference}}" width="100%" height="inherit" >
        <mat-spinner *ngIf="loading" class="card-img"></mat-spinner>
    </div>
    <div class="card-body">
        <h2 class="card-title">{{ element.reference }}</h2>
        <p class="card-text">{{ element.shortContent }}</p>
    </div>
    <!-- <div class="card-footer">
        <a [routerLink]="element.url">En savoir plus</a>
    </div> -->
</div>